import moment from 'moment';
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import { hebrewDateType } from '../../../../../enums/hebrewDateType';
import CalendarEventPopup from '../../../calenderPage/calendarEventPopup/CalendarEventPopup';
import MyTooltipComponent from '../../../../ui/myTooltipComponent/MyTooltipComponent';
import VIcon from '../../../../../../assests/icons/VIcon.png';
import Icon from '../../../../ui/icons/Icon';
import iconsList from '../../../../ui/icons/iconsList';
import useHebrewDate from '../../../../../hooks/useHebrewDate ';
import classes from './TimeLineCard.module.css';

const TimeLineCard = ({ fake, picture, title, description, date, color }) => {

    const hebrewDate = useHebrewDate();

    return (
        <div className={`${classes.TimeLineCard} ${fake ? classes.Fake : ''} ${new Date(date) < new Date() ? classes.PastCard : ''}`}>
            <MyTooltipComponent
                offsetX={-15}
                offsetY={-15}
                Content={() => <div onClick={e => e.stopPropagation()}>
                    <CalendarEventPopup
                        Picture={picture}
                        Subject={title}
                        Description={description}
                        IsAllDay={true}
                        StartTime={date}
                        EndTime={date} />
                </div>}
                modeOpen={"Click"}
                className={classes.DropTooltip}
                hidden={fake}
            >
                <p className={classes.Circle} style={{ backgroundColor: color }} tabIndex="0">
                    <AccessibilityHiddenImg className={classes.VIcon} src={VIcon} />
                </p >
            </MyTooltipComponent>
            <div className={classes.Line} style={{ borderTopColor: color }}></div>

            <div className={classes.Content} id='clickButton'>
                <div className={classes.Date}>
                    <Icon className={classes.DateIcon} name={iconsList.bagrut} size="13px" color={fake ? "#8d8d8d66" : color} />
                    <p style={{ color: color }}>{moment(date).format("DD.MM")}</p>
                    {/* <p style={{ color: color }}>{`| ${hebrewDate(new Date(date), hebrewDateType.day)} ${hebrewDate(new Date(date), hebrewDateType.month)}`}</p> */}
                </div>
                <p style={{ color: color }} className={classes.Title} >{title}</p>
            </div>
        </div >
    )
}

export default TimeLineCard; 